import { render } from "./ownChat.vue?vue&type=template&id=89380d24&scoped=true&ts=true"
import script from "./ownChat.vue?vue&type=script&lang=ts"
export * from "./ownChat.vue?vue&type=script&lang=ts"

import "./ownChat.vue?vue&type=style&index=0&id=89380d24&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89380d24"]])

export default __exports__